export default "__VITE_ASSET__c6500496__"